import type { FC } from 'react';
import React from 'react';
import classnames from 'classnames';

import styles from './emptyBlock.module.css';

interface IMobile {
  isMobile?: boolean;
}

interface IEmptyBlock extends IMobile {
  className: string;
  icon: any;
  title: string;
  subtitle: string;
}

const EmptyBlock: FC<IEmptyBlock> = ({
  className = '',
  isMobile = false,
  icon,
  title,
  subtitle,
}) => (
  <div
    className={classnames(styles.container, className, {
      [styles.containerMobile]: isMobile,
    })}
  >
    {icon}
    <div
      className={classnames(styles.header, {
        [styles.headerMobile]: isMobile,
      })}
    >
      {title}
    </div>
    <div
      className={classnames(styles.text, {
        [styles.textMobile]: isMobile,
      })}
    >
      {subtitle}
    </div>
  </div>
);

export default EmptyBlock;
